import { Company } from "../../../../models";
import { StandardAxiosConfig, USER_NOT_LINKED } from "../../../common";
import type { User } from "../../../../models";
import { DataAPI_Base, GetAPI_Base, UpdateAPI_Base } from "../base";
import axios from "axios";

class GetAPI_Companies extends GetAPI_Base<Company> {
	constructor() {
		super("companies", Company);
	}

	public async byUser(user: Pick<User, "companyIdsAll">) {
		if (user.companyIdsAll.length === 0) throw new Error(USER_NOT_LINKED);

		const allCompanies = await super.byIds(user.companyIdsAll);
		if (allCompanies[0].id && allCompanies[0].name.toLowerCase() === "rogo ag") {
			const activeCompanies = await super.byFilter({
				type: "OR",
				fields: [{ isActive: 1 }],
			});
			allCompanies.push(...activeCompanies);
		}

		const uniqueCompanies = allCompanies.filter(
			(company, index, self) => index === self.findIndex((t) => t.id === company.id),
		);

		return uniqueCompanies;
	}
}

class UpdateAPI_Companies extends UpdateAPI_Base<Company> {
	constructor() {
		super("companies");
	}

	public async portalSettings(id: string, value: any) {
		const url = `${this.baseUrl}/${id}/portal-settings`;
		await axios.post(url, value, StandardAxiosConfig());
	}

	public async portalConfigurationOptions(id: string, value: string[]) {
		const url = `${this.baseUrl}/${id}/portal-configuration-options`;
		await axios.post(url, value, StandardAxiosConfig());
	}
}

export class CompaniesAPI extends DataAPI_Base<Company> {
	get: GetAPI_Companies;
	update: UpdateAPI_Companies;

	constructor() {
		super("companies", Company);
		this.get = new GetAPI_Companies();
		this.update = new UpdateAPI_Companies();
	}
}
